import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject } from '@mri/types';

@Pipe({
  name: 'listRender'
})
export class CardListRenderPipe implements PipeTransform {

  transform(elements: AnyObject[],
            selectedIds: Set<string>,
            marks: Record<string, Set<string>>,
            joints: Record<string, Record<string, AnyObject>>, ...args: AnyObject[]
  ): Array<AnyObject> | undefined {
    if (!Array.isArray(elements))
      return undefined;

    return elements.map(element => {
      const id = element._id;
      element.$marks = {};
      element.$joint = {};

      Object.keys(marks || {}).forEach(key => {
        const set = marks[key];
        element.$marks[key] = set.has(id);
      });

      Object.keys(joints || {}).forEach(key => {
        const joint = joints[key] || {};
        element.$joint[key] = joint[id];
      });

      element.$selected = selectedIds.has(id);

      return element;
    });
  }

}
